import './index.css';
const OFFSET_ATTR = Symbol('scroll-item-offset');

export { OFFSET_ATTR };
//# sourceMappingURL=types.js.map
